import Dashboard from "@/views/admin/dashboard/Dashboard";

export default {
  path: "/admin/dashboard/principal",
  name: "dashboard",
  component: Dashboard,
  props: true,
  meta: {
    requiresAuth: true
  }
};
